<div class="navigation-bar" [class.navigation-bar--junior]="activeFlow() === 'junior'">
  <ng-container *ngFor="let item of items(); let i = index">
    <ng-container [ngTemplateOutlet]="!item.disabled ? enabledLink : disabledLink" [ngTemplateOutletContext]="{item, i}"></ng-container>
    <div class="navigation-bar__item__separator" *ngIf="i < items().length - 1">
      <div class="navigation-bar__item__separator__line"></div>
    </div>
  </ng-container>
</div>

<ng-template #enabledLink let-item="item" let-i="i">
  <a
    tabindex="0"
    role="link"
    [routerLink]="item.routerLink"
    [routerLinkActive]="'navigation-bar__item--active'"
    class="navigation-bar__item"
    [attr.data-qa]="item.label?.toLowerCase() + '_navigator'"
    lxGAClickBackEvent
  >
    <ng-container [ngTemplateOutlet]="linkBody" [ngTemplateOutletContext]="{item, i}"></ng-container>
  </a>
</ng-template>

<ng-template #disabledLink let-item="item" let-i="i">
  <div class="navigation-bar__item navigation-bar__item--disabled" [attr.data-qa]="item.label?.toLowerCase() + '_navigator'">
    <ng-container [ngTemplateOutlet]="linkBody" [ngTemplateOutletContext]="{item, i}"></ng-container>
  </div>
</ng-template>

<ng-template #linkBody let-item="item" let-i="i">
  <ng-container
    [ngTemplateOutlet]="item.icon ? iconTemplate : numberTemplate"
    [ngTemplateOutletContext]="{ $implicit: item.icon ? item.icon : i + 1 }"
  ></ng-container>
  <span class="navigation-bar__item__title"> {{ item.label }}</span>
</ng-template>

<ng-template #iconTemplate let-icon>
  <span class="navigation-bar__item__step"> <i class="pi pi-{{ icon }}"></i></span>
</ng-template>

<ng-template #numberTemplate let-stepNumber>
  <span class="navigation-bar__item__step"> {{ stepNumber }}</span>
</ng-template>
